import { DeleteOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { ConfirmAction, } from 'components';
import { useDeleteProjectToolMutation } from 'app/services/tools';
import { ProjectTool } from 'app/types/tool';

const DeleteTool = ({ projectTool }: { projectTool: ProjectTool }) => {
  const { t } = useTranslation();
  const [ deleteProjectTool, meta ] = useDeleteProjectToolMutation();

  const handleRemoveClick = async (projectTool: ProjectTool) => {
    await deleteProjectTool(projectTool.Id).unwrap();
  };

  return <ConfirmAction
    callback={() => handleRemoveClick(projectTool)}
    successMessage={t('common.deletesuccess', { content: projectTool.Label })}
    confirmMessage={t('common.deleteconfirm', { content: projectTool.Label })}
    meta={meta}
    tooltipButtonProps={{
      title: t('common.delete'),
      minimized: true,
      buttonProps: {
        danger: true,
        type: 'link',
        icon: <DeleteOutlined />,
      }
    }}
  />;


};

export default DeleteTool;